export default {
  nav: {
    home: "Home",
    engines: "Engines",
    transmissions: "Transmissions",
    bodyParts: "Body Parts",
    testimonials: "Testimonials",
    contact: "Contact Us",
    getQuote: "Get a Quote",
    menu: "Toggle menu",
  },
  banner: {
    text: "BIG SALE ON NOW — Up to 30% OFF selected engines, transmissions & body parts. Australia-wide shipping available.",
  },
  hero: {
    badge: "Trusted Since 2005",
    title1: "Quality Used Engines &",
    titleHighlight: "Transmissions",
    desc: "{{siteName}} is your one-stop shop for used, new and aftermarket spare parts, delivered Australia-wide. Specialists in the most popular Australian-market utes and SUVs.",
    contact: "Contact Us",
    browse: "Browse Engines",
  },
  about: {
    f1title: "Family Owned",
    f1text: "{{siteName}} is a family-run Darwin business built on trust, hard work and genuine care for every customer we serve.",
    f2title: "Reputation",
    f2text: "We enjoy a strong reputation built on integrity, fairness and technical knowledge across used, new and aftermarket parts.",
    f3title: "What We Do",
    f3text: "We are your one-stop shop for used, new and aftermarket spare parts, backed by a specialist service and repair workshop.",
    f4title: "Highly Skilled",
    f4text: "Our experienced technicians use the latest diagnostic programs and scanners to help you avoid unnecessary repair costs.",
    stockLabel: "What we stock",
    modelsTitle: "Popular Models We Cover",
    modelsDesc: "We focus on the best-selling Australian utes and SUVs so you get the right part, fast.",
  },
  why: {
    promise: "Our promise",
    title: "Why Choose Us",
    w1title: "Quality",
    w1text: "Peace of mind knowing you've been supplied a high quality part and service, every time.",
    w2title: "Savings",
    w2text: "Keep more money in your pocket with our excellent discounts on all parts, new and used.",
    w3title: "Warranty",
    w3text: "New parts come with 12 month warranty and used parts with 3 month warranty.",
    w4title: "Shipping",
    w4text: "Small items ship overnight, and larger items within 1 to 3 days across Australia.",
    missionTitle: "Our Mission",
    missionText: "To provide you, our customers and community, with world-class customer service. We aim to achieve the highest quality in everything we do to best serve you — through our four value pillars of Family, Driven, Innovation & Quality.",
    valuesTitle: "Our Values",
    v1label: "Family",
    v1text: "We're one team who care about our customers, our people and our suppliers.",
    v2label: "Driven",
    v2text: "We strive for the best in what we do, with a real passion for success.",
    v3label: "Innovation",
    v3text: "We think outside the square and work hard to continuously improve.",
    v4label: "Quality",
    v4text: "We endeavour to do it right the first time, every time.",
    t1text: "Awesome service. Fixed the job same day and communicated with me the whole way through — all for an excellent price!",
    t1name: "Nico A.",
    t1loc: "Darwin",
    t2text: "Found the exact engine I needed for my HiLux. Friendly, honest and really knowledgeable on Australian utes. Highly recommend.",
    t2name: "Chris N.",
    t2loc: "Palmerston",
    t3text: "Very helpful, fair and honest with quality second-hand parts from all the popular models. Big thumbs up!",
    t3name: "Stephen C.",
    t3loc: "Darwin",
    t4text: "Turned up with unknown issues, and these guys had me back up and running quickly. Fantastic service.",
    t4name: "Armand D.",
    t4loc: "Katherine",
  },
  brand: {
    strip: "Parts for all major marques",
  },
  cta: {
    title: "Looking for a Part?",
    desc: "Tell us what you need and our team will source it for you. We ship across Australia from our Winnellie, Darwin workshop.",
    request: "Request a Quote",
  },
  footer: {
    brandDesc: "Australia's trusted source for quality used engines, transmissions and body parts. Family-owned and focused on the most popular Australian utes and SUVs.",
    quickLinks: "Quick Links",
    company: "Company",
    getInTouch: "Get In Touch",
    monFri: "Mon - Fri: 8:00am - 5:00pm",
    copyright: "© Copyright {{year}} {{siteName}}. All Rights Reserved.",
    disclaimer: "{{siteName}} is an independent parts and service specialist.",
  },
  page: {
    enginesSubtitle: "Quality used, new and reconditioned engines for all car makes and models – European, Japanese and American. Every engine is inspected, sealed and supplied with warranty.",
    transmissionsSubtitle: "Used and new automatic and manual transmissions for all makes and models – European, Japanese and American. Every gearbox is inspected, tested and supplied with warranty.",
    bodyPartsSubtitle: "Used and aftermarket body panels, bumpers, mirrors, lights and trims for all makes and models. Straight panels, competitively priced with warranty.",
  },
  grid: {
    ourStock: "Our stock",
    itemsInStock: "{{count}} items in stock",
    shipping: "Australia-wide shipping",
    price: "Price",
    enquire: "Enquire Now",
    searchPlaceholder: "Search by make, model or part name...",
    allMakes: "All makes",
    allModels: "All models",
    noResults: "No parts match your search. Try a different make or model.",
    clearFilters: "Clear filters",
  },
  availability: {
    badge: "Stock update",
    title: "Used & New {{category}}",
    text: "We have car engines, transmissions and body parts for all car makes and models. We offer a wide range of engines, transmissions and body parts for European, Japanese, Canadian and American cars. All parts are inspected and meet the quality requirements they are subject to; every item is sealed and bears a special mark. All used parts come with a long-term quality guarantee. If you have any doubts about your engine, transmission or body part choice, please contact our team – we'll be happy to answer your questions and give you comprehensive advice. {{siteName}} – a convenient search for used & new parts, with fast delivery of goods within 1–3 business days after the payment receipt date.",
    cta: "Contact Us",
  },
  request: {
    badge: "Missing a part?",
    title: "Can't Find the Part You Need?",
    text: "{{siteName}} sources hard-to-find engines, transmissions and body parts every week. Tell us your make, model and year — if it's not on the shelf today, our team will track it down and get back to you fast.",
    cta: "Request a Part",
  },
  partsWeSource: {
    badge: "Special Order",
    title: "Parts We Source",
    desc: "Can't see what you're after? {{siteName}} tracks down hard-to-find parts every week — from rare ECUs and computer boxes to those one-off bits nobody else stocks.",
    ecuTitle: "ECUs & Control Units",
    ecuText: "Engine, transmission and body control modules, programmed and test-fitted to your vehicle.",
    computerBoxTitle: "Computer Boxes",
    computerBoxText: "Engine-management computer boxes and wiring-matched modules for utes, SUVs and more.",
    hardToFindTitle: "Hard-to-Find Parts",
    hardToFindText: "Rare trims, discontinued panels and specialist parts sourced through our nationwide network.",
    cta: "Request a Part",
  },
  contact: {
    badge: "Get in touch",
    title: "Contact Us",
    desc: "Have a part in mind? Send us an enquiry and our team will get back to you promptly. We ship across Australia from Winnellie, Darwin NT 0820.",
    sendEnquiry: "Send an Enquiry",
    formDesc: "Fill in the form and we'll be in touch shortly.",
    prefill: "We've pre-filled the part you're enquiring about. Just add your details and any notes below.",
    name: "Name",
    namePlaceholder: "Your full name",
    email: "Email",
    emailPlaceholder: "you@email.com",
    phone: "Phone",
    phonePlaceholder: "+61 4xx xxx xxx",
    subject: "Subject",
    subjectPlaceholder: "Select a topic",
    subjectEngine: "Engine Enquiry",
    subjectTransmission: "Transmission Enquiry",
    subjectBody: "Body Parts Enquiry",
    subjectGeneral: "General Enquiry",
    subjectSpecialOrder: "Special Order / Part Request",
    part: "Part / Item enquired about",
    partPlaceholder: "e.g. Engine – Toyota HiLux 2018",
    vehicle: "Vehicle (Make, Model & Year)",
    vehiclePlaceholder: "e.g. Toyota HiLux 2018",
    notes: "Notes",
    notesPlaceholder: "Tell us the part you're looking for...",
    maxChars: "Max 500 characters",
    partPhoto: "Photo of the part (optional)",
    partPhotoHint: "JPG, PNG or WebP, up to 8 MB. Helps us identify the exact part faster.",
    choosePhoto: "Choose Photo",
    removePhoto: "Remove photo",
    photoInvalid: "Please choose an image file (JPG, PNG or WebP).",
    photoTooLarge: "That image is too large. Please choose one under 8 MB.",
    success: "Thanks for your enquiry! We'll get back to you shortly.",
    sending: "Sending...",
    send: "Send Enquiry",
    details: "Our Details",
    addressLabel: "Address",
    phoneLabel: "Phone",
    emailLabel: "Email",
    hoursLabel: "Opening Hours",
    sat: "Sat: By appointment",
  },
  detail: {
    home: "Home",
    photos: "Photos",
    specifications: "Specifications",
    make: "Make",
    model: "Model",
    year: "Year Range",
    fitment: "Fitment",
    condition: "Condition",
    warranty: "Warranty",
    notFound: "This part could not be found. It may have been sold or removed.",
    backHome: "Back to Home",
    backToList: "Back to Listing",
  },
};